import { parseLocalDate } from "@/lib/utils";
import { Megaphone } from "lucide-react";
import { Panel, PanelRow } from "@/components/brand/Panel";

export interface Announcement {
  id: string;
  startDate: string;
  endDate: string;
  title: string;
  content: string;
}

interface AnnouncementsSectionProps {
  announcements: Announcement[];
}

const AnnouncementsSection = ({ announcements }: AnnouncementsSectionProps) => {
  if (announcements.length === 0) return null;

  return (
    <Panel icon={Megaphone} title="Special Announcements">
      {announcements.map((announcement) => (
        <PanelRow key={announcement.id}>
          <div className="flex flex-wrap items-baseline justify-between gap-x-4 gap-y-1">
            <h3 className="font-medium text-foreground">
              {announcement.title}
            </h3>
            {/* On the title's baseline rather than a line of its own. It is
                the least important thing in the row and used to cost it a
                third of the row's height. */}
            <p className="text-xs tabular-nums text-muted-foreground">
              Valid:{" "}
              {parseLocalDate(announcement.startDate).toLocaleDateString()} to{" "}
              {parseLocalDate(announcement.endDate).toLocaleDateString()}
            </p>
          </div>
          <p className="mt-1 text-sm text-muted-foreground">
            {announcement.content}
          </p>
        </PanelRow>
      ))}
    </Panel>
  );
};

export default AnnouncementsSection;
